<div class="branching-container">
  <div class="skinny-card">
    <div *ngFor="let branch of config.branches; let i = index" class="flexed branch-item">
      <div class="branch-connector"></div>
      <div class="branch-content">
        <ion-card
          class="action-card skinny-card branch-card"
          [@listAnimation]="animationStep === branch ? 'active' : 'inactive'"
        >
          <ion-list class="no-padding">
            <ion-item>
              <ion-label>
                <h3 class="condition-title">Condition {{ i + 1 }}</h3>
              </ion-label>
              <ion-button
                (click)="removeBranch(i)"
                color="dark"
                fill="clear"
                class="item-accessory-button"
                slot="end"
                [hidden]="config.branches.length <= (config.minBranches || 1)"
              >
                <ion-icon name="trash"></ion-icon>
              </ion-button>
            </ion-item>
          </ion-list>
          <div class="filter-content">
            <app-filter-button
              [options]="filterOptions"
              [selected]="branch.filters"
              (didChange)="branchFiltersDidChange(branch, $event)"
              [allowNotEqualsOperator]="true"
              [projectId]="projectId ?? undefined"
            ></app-filter-button>
            <p
              *ngIf="config.branches.length > 1 && i === config.branches.length - 1 && !branch.filters?.size"
              class="fallback-text"
            >
              Fallback condition - these options will be shown when no other conditions match
            </p>
          </div>
        </ion-card>

        <!-- Generic content area for the branch -->
        <ng-container
          *ngTemplateOutlet="stepTemplate; context: { $implicit: branch, branch: branch, index: i }"
        ></ng-container>
      </div>
    </div>

    <div class="add-button-container">
      <ion-button
        (click)="addBranch()"
        color="dark"
        fill="clear"
        class="btn-small button-dark-border"
        slot="end"
        [disabled]="config.maxBranches && config.branches.length >= config.maxBranches"
      >
        <ion-icon name="add"></ion-icon>
        Add condition
      </ion-button>
    </div>

    <!-- Bottom connector lines -->
    <div class="flexed">
      <div class="bottom-connector-left"></div>
      <div class="bottom-connector-right"></div>
    </div>
  </div>
</div>
